import BookBtn from '../buttons/BookBtn/BookBtn';

const Modal = () => {
  return (
    <div className='container'>
      <div className='modal'>
        <div className='notification'>
          <div className='icon'></div>
          <p className='modal-title'>Thank you</p>
          <p className='modal-text'>Your message has been sent! We will contact you soon.</p>
          <BookBtn url='/' text='Go to main page' />
        </div>
      </div>
    </div>
  );
};

export default Modal;

